import { NodeViewWrapper } from "@tiptap/react";
import service1 from '../../../../../assets/images/ourservices/service1.png';
import service2 from '../../../../../assets/images/ourservices/service2.png';
import service3 from '../../../../../assets/images/ourservices/service3.png';
import service4 from '../../../../../assets/images/ourservices/service4.png';
import service5 from '../../../../../assets/images/ourservices/service5.png';

const servicesData = [
    {
        title: "Planning & Feasibility",
        imagePath: service1
    },
    {
        title: "Design Review",
        imagePath: service2
    },
    {
        title: "Cost Estimation & Budgeting",
        imagePath: service3
    },
    {
        title: "Project Management",
        imagePath: service4
    },
    {
        title: "Quality Assurance",
        imagePath: service5
    }
];

export const OurServicesBlockView = (props) => {
    const { editor, getPos } = props;

    const handleCaptionClick = () => {
        const nodePosition = getPos();
        editor.commands.setNodeSelection(nodePosition);
    };

    return (
        <NodeViewWrapper data-type='ourservices'>
            <div className="ourservices-node-wrapper">
                <div onClick={handleCaptionClick}>
                    <div className='ourservices-content'>
                        <h5>Our Services</h5>
                        <div className="ourservices-grid">
                            {servicesData.map((item, index) => (
                                <div key={index} className="ourservices-item">
                                    <div className="ourservices-image">
                                        <img src={item.imagePath} alt={item.title} />
                                    </div>
                                    <p className="ourservices-title">{item.title}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </NodeViewWrapper>
    );
};